import { Controller } from "@hotwired/stimulus";

// Dispatches "mobile-panel:open" on window so the mobile panel controller can open.
// Usage: data-controller="mobile-panel-trigger" data-action="click->mobile-panel-trigger#fire"
export default class extends Controller {
  fire() {
    window.dispatchEvent(new CustomEvent("mobile-panel:open"));
  }
}
